import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: "4px 4px",
    gap: "4px",
    display: "flex",
    flexWrap: "wrap",
  },
  activeFilterBtn: {
    background: "#0F56CA !important",
    border: "1px solid #0F56CA !important",
    color: "white !important",
  },
}));
